<template>
  <span class="t-help">
    <!-- Trigger -->
    <b-link
        class="ml-1 text-black-75 opacity-6-hover"
        :class="{'remove-pointer':!click,'help-link-click':click}"
        tabindex="10000"
        @click.prevent="handleClick"
        v-b-tooltip.hover.html="tooltipOptions"
    >
      <b-icon-info-circle />
    </b-link>

    <!-- Modal (somente quando click=true) -->
    <b-modal
        v-if="click"
        :id="localModalId"
        :title="modalTitleComputed"
        :size="size"
        :hide-footer="hideFooter"
        :ok-only="okOnly"
        ok-title="Fechar"
        @hidden="$emit('hidden')"
        @shown="$emit('shown')"
    >
      <slot>
        <!-- Fallback caso nao venha slot -->
        <div v-if="title" v-html="title"></div>
      </slot>
    </b-modal>
  </span>
</template>

<script>

export default {
  name: "t-help",
  props: {
    title: {
      type: String,
      default: ""
    },
    click: {
      type: Boolean,
      default: false
    },

    /* Modal options */
    modalTitle: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md" // sm, md, lg, xl
    },
    centered: {
      type: Boolean,
      default: true
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    okOnly: {
      type: Boolean,
      default: true
    },

    /* Tooltip options */
    tooltipClass: {
      type: String,
      default: "help-tooltip"
    }
  },
  data() {
    return {
      localModalId: null
    };
  },
  mounted() {

    this.localModalId = "t-help-" + Math.random().toString(36).slice(2, 10);

  },
  computed: {

    modalTitleComputed() {
      return this.modalTitle || this.title || "Ajuda";
    },
    tooltipOptions() {
      // Tooltip so quando NAO for click
      if (this.click) return null;

      return {
        customClass: this.tooltipClass,
        title: this.title
      };
    }
  },
  methods: {
    handleClick() {
      if (!this.click) return;
      this.$bvModal.show(this.localModalId);
      this.$emit("open");
    }
  }
};
</script>

<style scoped>
/* opcional: mantem o componente inline e evita quebrar layout */
.t-help {
  display: inline-block;
}
</style>
